
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19.211 19.21"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_30413","data-name":"Group 30413","transform":"translate(-1650.188 -21.4)","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2"}},[_c('path',{attrs:{"id":"Path_360","data-name":"Path 360","d":"M757.123 338.87a3.177 3.177 0 11-3.177-3.177 3.177 3.177 0 013.177 3.177z","transform":"translate(905.847 -307.865)"}}),_c('path',{attrs:{"id":"Path_361","data-name":"Path 361","d":"M760.277 336.613v-.835a1.421 1.421 0 00-1.421-1.421h0a1.3 1.3 0 01-.922-2.225h0a1.421 1.421 0 000-2.009l-.591-.591a1.421 1.421 0 00-2.009 0h0a1.3 1.3 0 01-2.225-.922h0a1.42 1.42 0 00-1.421-1.42h-.835a1.42 1.42 0 00-1.42 1.42h0a1.3 1.3 0 01-2.225.922h0a1.422 1.422 0 00-2.009 0l-.59.591a1.42 1.42 0 000 2.009h0a1.3 1.3 0 01-.922 2.225h0a1.421 1.421 0 00-1.421 1.42v.836a1.421 1.421 0 001.421 1.42h0a1.3 1.3 0 01.922 2.226h0a1.42 1.42 0 000 2.009l.59.59a1.42 1.42 0 002.009 0h0a1.3 1.3 0 012.225.922h0a1.421 1.421 0 001.42 1.421h.836a1.421 1.421 0 001.42-1.421h0a1.3 1.3 0 012.225-.922h0a1.42 1.42 0 002.009 0l.59-.59a1.42 1.42 0 000-2.009h0a1.3 1.3 0 01.922-2.226h0a1.421 1.421 0 001.422-1.42z","transform":"translate(908.522 -305.19)"}})])])
          )
        }
      }
    